/* eslint-disable max-lines */
import {
    ADD_CANBUSTYPES,
    ADD_TRANSLATIONS,
    ADD_ERRORS,
    SET_DEVICE_SERIAL_NUMBER,
    SET_CONTRACT_NUMBER,
    SET_LICENSE_PLATE,
    SET_DEVICE_ACTIVATION_KEY,
    SET_CHOOSED_PROPERTY_TYPE,
    SET_ACTIVATION_CODE,
    SET_CUSTOMER_NUMBER,
    SET_TARIFFS,
    SET_WFSUBSCRIPTION,
    SET_FETCH_TRANSLATE_SUCCESS,
    SET_FETCH_PROCESS_SUCCESS,
    SET_SUBSCRIPTION_SELECTED_PAGE,
    SET_SELECTED_SUBSCRIPTION_OPTION,
    SET_RMA_DEVICES,
    SET_RMA_DEVICE_SERIAL_NUMBER,
    SET_PROVIDER_NO,
    SET_IS_DAK_DEVICE,
    SET_GENERATION_REQUIRED,

    // VEHICLE GENERATION SELECTION
    SET_FUELTYPE_INDEX,
    SET_FUELTYPES_GROUP,
    SET_BRANDS,
    SET_MODELS,
    SET_GENERATIONS,
    SET_GENERATION_SELECTED,
    SET_GENERATION_OBJECT,
    SET_MODEL_ID,
    SET_BRAND_ID,
    SET_GENERATION_ID_SELECTED,
    SET_TANK_SIZE
} from './actionTypes'

const addCanBusTypes = content => {
    return {
        payload: {
            content
        },
        type: ADD_CANBUSTYPES
    }
}

const setFetchTranslateSuccess = content => {
    return {
        payload: {
            content
        },
        type: SET_FETCH_TRANSLATE_SUCCESS
    }
}

const setTankSize = content => {
    return {
        payload: {
            content
        },
        type: SET_TANK_SIZE
    }
}

const addErrors = content => {
    return {
        payload: {
            content
        },
        type: ADD_ERRORS
    }
}

const setFetchProcessSuccess = content => {
    return {
        payload: {
            content
        },
        type: SET_FETCH_PROCESS_SUCCESS
    }
}

const addTranslations = content => {
    return {
        payload: {
            content
        },
        type: ADD_TRANSLATIONS
    }
}

const setDeviceSerialNumber = content => {
    return {
        payload: {
            content
        },
        type: SET_DEVICE_SERIAL_NUMBER
    }
}

const setRmaDeviceSerialNumber = content => {
    return {
        payload: {
            content
        },
        type: SET_RMA_DEVICE_SERIAL_NUMBER
    }
}

const setSubscriptionSelectedPage = content => {
    return {
        payload: {
            content
        },
        type: SET_SUBSCRIPTION_SELECTED_PAGE
    }
}

const setDeviceActivationKey = content => {
    return {
        payload: {
            content
        },
        type: SET_DEVICE_ACTIVATION_KEY
    }
}

const setSelectedSubscriptionOption = content => {
    return {
        payload: {
            content
        },
        type: SET_SELECTED_SUBSCRIPTION_OPTION
    }
}

const setContractNumber = content => {
    return {
        payload: {
            content
        },
        type: SET_CONTRACT_NUMBER
    }
}

const setLicensePlate = content => {
    return {
        payload: {
            content
        },
        type: SET_LICENSE_PLATE
    }
}

const setProviderNo = content => {
    return {
        payload: {
            content
        },
        type: SET_PROVIDER_NO
    }
}

const setWfSubscription = content => {
    return {
        payload: {
            content
        },
        type: SET_WFSUBSCRIPTION
    }
}

const setIsDakDevice = content => {
    return {
        payload: {
            content
        },
        type: SET_IS_DAK_DEVICE
    }
}

const setTariffs = content => {
    return {
        payload: {
            content
        },
        type: SET_TARIFFS
    }
}

const setRmaDevices = content => {
    return {
        payload: {
            content
        },
        type: SET_RMA_DEVICES
    }
}

const setChoosedPropertyType = content => {
    return {
        payload: {
            content
        },
        type: SET_CHOOSED_PROPERTY_TYPE
    }
}

const setActivationCode = content => {
    return {
        payload: {
            content
        },
        type: SET_ACTIVATION_CODE
    }
}

const setCustomerNumber = content => {
    return {
        payload: {
            content
        },
        type: SET_CUSTOMER_NUMBER
    }
}

// VEHICLE GENERATION SELECTION

const setBrands = content => {
    return {
        payload: {
            content
        },
        type: SET_BRANDS
    }
}

const setModels = content => {
    return {
        payload: {
            content
        },
        type: SET_MODELS
    }
}

const setGenerations = content => {
    return {
        payload: {
            content
        },
        type: SET_GENERATIONS
    }
}

const setGenerationSelected = content => {
    return {
        payload: {
            content
        },
        type: SET_GENERATION_SELECTED
    }
}

const setGenerationIdSelected = content => {
    return {
        payload: {
            content
        },
        type: SET_GENERATION_ID_SELECTED
    }
}

const setGenerationObject = content => {
    return {
        payload: {
            content
        },
        type: SET_GENERATION_OBJECT
    }
}

const setBrandId = content => {
    return {
        payload: {
            content
        },
        type: SET_BRAND_ID
    }
}

const setModelId = content => {
    return {
        payload: {
            content
        },
        type: SET_MODEL_ID
    }
}

const setFuelTypeIndex = content => {
    return {
        payload: {
            content
        },
        type: SET_FUELTYPE_INDEX
    }
}

const setFuelTypesGroup = content => {
    return {
        payload: {
            content
        },
        type: SET_FUELTYPES_GROUP
    }
}

const setGenerationRequired = content => {
    return {
        payload: {
            content
        },
        type: SET_GENERATION_REQUIRED
    }
}

export {
    addCanBusTypes,
    addErrors,
    addTranslations,
    setActivationCode,
    setBrandId,
    setBrands,
    setChoosedPropertyType,
    setContractNumber,
    setCustomerNumber,
    setDeviceActivationKey,
    setDeviceSerialNumber,
    setFetchProcessSuccess,
    setFetchTranslateSuccess,
    setFuelTypeIndex,
    setFuelTypesGroup,
    setGenerationIdSelected,
    setGenerationObject,
    setGenerationRequired,
    setGenerationSelected,
    setGenerations,
    setIsDakDevice,
    setLicensePlate,
    setModelId,
    setModels,
    setProviderNo,
    setRmaDeviceSerialNumber,
    setRmaDevices,
    setSelectedSubscriptionOption,
    setSubscriptionSelectedPage,
    setTariffs,
    setWfSubscription,
    setTankSize
}
